import styled from 'styled-components';
import { ButtonIconWrapper } from '../../components/Buttons/style';
import { FontFamilyRegular, FontSize14, FontSize18, FontFamilyMedium } from '../../components/fonts';
import { Title } from '../../components/titles';
import { MarginTop8 } from '../../components/margins';
import { TextBlock } from '../../components/text';

export const AccordionContainer = styled.div`
    margin-top: 60px;
    width: 100%;
`;

export const ButtonIconWrapperNoMargin = styled(ButtonIconWrapper)`
    margin: 0;
`;

export const Label = styled.p`
    ${FontFamilyRegular};
    ${FontSize14};
    margin-bottom: 10px;
    color: ${props => props.theme.color.darkBlue};
`;

export const EntryContent = styled.p`
    margin: 0;
    ${FontFamilyRegular};
    ${FontSize18};
    color: ${props => props.theme.color.darkGray};
`;

export const EntriesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const TitleSection = styled(Title)`
    width: 100%;
    ${MarginTop8};
`;

export const LegalNotesContainer = styled.div`
    margin-top: 30px;
    cursor: pointer;
`;

export const LegalNotes = styled(TextBlock)`
    ${FontFamilyMedium};
    font-size: 13px;
    font-weight: 500;
    color: #c2c2c2;
`;